import classNames from "classnames";
import type { VFC, MouseEvent, ComponentPropsWithoutRef, ReactNode } from "react";

import { UnreadBadge } from "../UnreadBadge";
import { UnreadCountBadge } from "../UnreadCountBadge";

import { style } from "./index.styles";

type Props = ComponentPropsWithoutRef<"button"> & {
  onClick: (event: MouseEvent<HTMLElement>) => Promise<void>;
  unreadNotificationCount: number;
  unreadServiceNotification: boolean;
  badgeClassName?: string;
  children: ReactNode;
};

export const NotificationButtonWithBadge: VFC<Props> = (props) => {
  const { onClick, unreadNotificationCount, unreadServiceNotification, badgeClassName, children, className } = props;

  const renderBadge = () => {
    if (0 < unreadNotificationCount) {
      return <UnreadCountBadge unreadCount={unreadNotificationCount} />;
    }

    return <UnreadBadge unread={unreadServiceNotification} className={badgeClassName} />;
  };

  return (
    <button type="button" className={classNames(className)} css={style} onClick={onClick}>
      {children}
      {renderBadge()}
    </button>
  );
};
